import { useMemo, useState } from "react";
import { MoreHorizontal, ArrowRightLeft, Star, Power, Trash2, Handshake } from "lucide-react";

// Menù «⋯» dell'intestazione: le azioni che prima erano riquadri sparsi in alto.
export default function AzioniPratica({ pratica, onCambiaTipo, onTrasforma, onPriorita, onAttiva, onSponsor, onElimina, puoEliminare }) {
  const [open, setOpen] = useState(false);
  const voci = useMemo(() => [
    { k: "tipo", l: "Cambia tipo di pratica", i: ArrowRightLeft, f: onCambiaTipo },
    ...(!pratica.trasformata_in && (pratica.puo_trasformare || pratica.puo_collegare)
      ? [{ k: "trasforma", l: pratica.puo_trasformare ? "Trasforma in pratica" : "Apri pratica collegata", i: ArrowRightLeft, f: onTrasforma }] : []),
    { k: "priorita", l: pratica.priorita ? "Togli dalle priorità" : "Segna come prioritaria", i: Star, f: onPriorita },
    { k: "attiva", l: pratica.attiva ? "Metti in pausa" : "Riattiva la pratica", i: Power, f: onAttiva },
    { k: "sponsor", l: pratica.ha_sponsor ? "Modifica sponsor o segnalatore" : "Aggiungi sponsor o segnalatore", i: Handshake, f: onSponsor },
    ...(puoEliminare ? [{ k: "elimina", l: "Elimina pratica", i: Trash2, f: onElimina, rosso: true }] : []),
  ], [pratica, onCambiaTipo, onTrasforma, onPriorita, onAttiva, onSponsor, onElimina, puoEliminare]);

  return (
    <div className="relative">
      <button data-testid="azioni-pratica" onClick={() => setOpen(!open)} aria-label="Altre azioni"
        className="w-10 h-10 grid place-items-center rounded-full border border-[#1A2B4A]/15 bg-white text-[#1A2B4A]
                   hover:border-[#C9A84C] hover:text-[#C9A84C] transition-colors">
        <MoreHorizontal className="w-5 h-5" />
      </button>
      {open && (
        <>
          <button aria-hidden className="fixed inset-0 z-[55] cursor-default" onClick={() => setOpen(false)} />
          <div data-testid="azioni-pratica-menu"
            className="absolute right-0 mt-2 z-[56] w-64 rounded-xl border border-[#1A2B4A]/12 bg-white shadow-[0_18px_38px_-18px_rgba(26,43,74,0.45)] overflow-hidden">
            {voci.map((v) => (
              <button key={v.k} data-testid={`azione-${v.k}`} onClick={() => { setOpen(false); v.f?.(); }}
                className={`w-full flex items-center gap-2.5 px-3.5 py-2.5 text-[13px] text-left transition-colors
                  ${v.rosso ? "text-[#9b2c2c] hover:bg-[#fdf6f6]" : "text-[#1A2B4A] hover:bg-[#fbf9f3]"}`}>
                <v.i className={`w-4 h-4 ${v.rosso ? "" : "text-[#C9A84C]"}`} /> {v.l}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
